import './pageAboutMe.css'

export default function PageAboutMe() {
    return (
        <div className="pageAboutMe-container">
            <p>About Me Page</p>
        </div>
    )
}